import React, { useState, useEffect, useRef } from "react";
import { ThemeCtx, ToastCtx, api, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination } from "../shared.js";

export function PageVulns({user,myVulns,setSelVuln}){
  var T=React.useContext(ThemeCtx).T;
  var _users=useState([]); var users=_users[0]; var setUsers=_users[1];
  useEffect(function(){api.get("/users").then(setUsers).catch(function(){});}, []);
  var PURPLE="#A100FF";
  var _search=useState(""); var search=_search[0]; var setSearch=_search[1];
  var _sev=useState(""); var sev=_sev[0]; var setSev=_sev[1];
  var _stat=useState(""); var stat=_stat[0]; var setStat=_stat[1];
  var _scanner=useState(""); var scanner=_scanner[0]; var setScanner=_scanner[1];
  var _sort=useState({col:"days_left",dir:"asc"}); var sort=_sort[0]; var setSort=_sort[1];
  var _vp=useState(1); var vPage=_vp[0]; var setVPage=_vp[1];
  var _selIds=useState([]); var selIds=_selIds[0]; var setSelIds=_selIds[1];
  var _bulkStat=useState(""); var bulkStat=_bulkStat[0]; var setBulkStat=_bulkStat[1];
  var _msg=useState(""); var msg=_msg[0]; var setMsg=_msg[1];
  var _scanTab=useState("all"); var scanTab=_scanTab[0]; var setScanTab=_scanTab[1];
  var SEV_C={Critical:"#e5534b",High:"#e8892b",Medium:"#c69026",Low:"#2ea043"};
  var STAT_C={Open:"#388bfd","In Progress":"#58a6ff",Remediated:"#2ea043",Exception:"#8957e5",Overdue:"#d29922","SLA Breach":"#e5534b"};
  var SCAN_GROUPS={
    all:null,
    appsec:["sast","dast","api","web","appsec"],
    infra:["infra","infrava","pt","pentest","network","va"],
    cloud:["cloud","aws","azure","gcp","aws_sh","azure_def","gcp_scc"],
    container:["container","sca","docker","image"],
    mobile:["mobile","mast","ios","android"],
    manual:["manual",""],
  };
  // Get unique scanners
  var scanners=[...new Set(myVulns.map(function(v){return v.scanner_name;}).filter(Boolean))];
  var filtered=myVulns.filter(function(v){
    if(sev&&v.severity!==sev) return false;
    if(stat&&v.status!==stat) return false;
    if(scanner&&v.scanner_name!==scanner) return false;
    if(scanTab!=="all"){
      var grp=SCAN_GROUPS[scanTab]||[];
      var st=(v.scan_type||"manual").toLowerCase();
      if(!grp.some(function(g){return st===g||st.includes(g);})) return false;
    }
    if(search){var q=search.toLowerCase();if(!(v.id+v.cve+v.title+v.asset+(v.owner_name||"")+(v.scan_type||"")+(v.scanner_name||"")).toLowerCase().includes(q)) return false;}
    return true;
  });

  var sorted=filtered.slice().sort(function(a,b){
    var av=a[sort.col],bv=b[sort.col];
    if(av==null)av=9999; if(bv==null)bv=9999;
    if(typeof av==="string") return sort.dir==="asc"?av.localeCompare(bv):bv.localeCompare(av);
    return sort.dir==="asc"?av-bv:bv-av;
  });

  var toggleSort=function(col){setSort(function(s){return s.col===col?{col:col,dir:s.dir==="asc"?"desc":"asc"}:{col:col,dir:"asc"};});setVPage(1);};
  var toggleSel=function(id){setSelIds(function(p){return p.includes(id)?p.filter(function(x){return x!==id;}):[...p,id];});};

  var bulkUpdate=async function(){
    if(!selIds.length||!bulkStat){setMsg("Select rows and a status");return;}
    if(!window.confirm("Change status of "+selIds.length+" vulnerabilities to "+bulkStat+"?")) return;
    try{
      await Promise.all(selIds.map(function(id){return api.patch("/vulns/"+id,{status:bulkStat});}));
      setMsg(selIds.length+" updated"); setSelIds([]);
    }catch(e){setMsg("Error: "+e.message);}
  };

  var thS={padding:"9px 10px",textAlign:"left",fontSize:10,fontWeight:700,color:T.text3,
    textTransform:"uppercase",letterSpacing:.8,background:T.inset,
    borderBottom:"1px solid "+T.border,whiteSpace:"nowrap",cursor:"pointer",userSelect:"none"};
  var tdS={padding:"9px 10px",fontSize:12,borderBottom:"1px solid "+T.border,verticalAlign:"middle"};

  // Status counts for summary cards
  var statuses=["Open","In Progress","Overdue","Exception","Remediated"];

  return React.createElement("div",{style:{display:"flex",flexDirection:"column",gap:12}},

    // Status summary cards
    React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(100px,1fr))",gap:8}},
      statuses.map(function(s){
        var cnt=myVulns.filter(function(v){return v.status===s;}).length;
        var pastSLA=s==="Overdue"?myVulns.filter(function(v){return v.days_left<0&&v.status!=="Remediated"&&v.status!=="Exception";}).length:0;
        var active=stat===s;
        var col=STAT_C[s]||PURPLE;
        return React.createElement("div",{key:s,onClick:function(){setStat(function(prev){return prev===s?"":s;});},
          style:{background:T.card,border:"2px solid "+(active?col:T.border),borderRadius:10,
            padding:"12px 14px",cursor:"pointer",boxShadow:T.cardShadow,transition:"all .15s"}},
          React.createElement("div",{style:{fontSize:22,fontWeight:800,color:col}},cnt),
          React.createElement("div",{style:{fontSize:10,color:T.text3,marginTop:2,fontWeight:600}},s),
          pastSLA>0&&React.createElement("div",{style:{fontSize:10,color:"#e5534b",marginTop:2}},pastSLA+" past SLA")
        );
      })
    ),

    // Scan-type tab bar
    React.createElement("div",{style:{display:"flex",gap:2,borderBottom:"0.5px solid "+T.border,
      flexWrap:"wrap",marginBottom:4}},
      [
        {id:"all",       label:"All"},
        {id:"appsec",    label:"AppSec"},
        {id:"infra",     label:"Infrastructure"},
        {id:"cloud",     label:"Cloud"},
        {id:"container", label:"Container / SCA"},
        {id:"mobile",    label:"Mobile"},
        {id:"manual",    label:"Manual"},
      ].map(function(t){
        var cnt=t.id==="all"?myVulns.length:myVulns.filter(function(v){
          var grp=SCAN_GROUPS[t.id]||[];
          var st=(v.scan_type||"manual").toLowerCase();
          return grp.some(function(g){return st===g||st.includes(g);});
        }).length;
        var active=scanTab===t.id;
        return React.createElement("button",{key:t.id,
          onClick:function(){setScanTab(t.id);},
          style:{padding:"8px 14px",border:"none",background:"transparent",
            cursor:"pointer",fontSize:12,fontWeight:active?600:400,
            color:active?T.accent:T.text3,fontFamily:"inherit",
            borderBottom:active?"2px solid "+T.accent:"2px solid transparent",
            marginBottom:-1,whiteSpace:"nowrap",
            display:"flex",alignItems:"center",gap:5}},
          t.label,
          React.createElement("span",{style:{fontSize:10,fontWeight:600,
            background:active?T.accent+"20":T.inset,
            color:active?T.accent:T.text3,
            borderRadius:10,padding:"1px 6px",minWidth:18,textAlign:"center"}},cnt)
        );
      })
    ),
    // Filters row
    React.createElement("div",{style:{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}},
      React.createElement("input",{placeholder:"Search ID, CVE, title, asset...",value:search,
        onChange:function(e){setSearch(e.target.value);},
        style:{flex:"1 1 200px",padding:"8px 12px",background:T.inset,border:"1px solid "+T.border,
          color:T.text,fontSize:12,outline:"none",borderRadius:8}}),
      React.createElement("select",{value:sev,onChange:function(e){setSev(e.target.value);},
        style:{padding:"7px 10px",background:T.inset,border:"1px solid "+T.border,color:T.text,fontSize:12,outline:"none",borderRadius:8}},
        React.createElement("option",{value:""},"All Severities"),
        ["Critical","High","Medium","Low"].map(function(s){return React.createElement("option",{key:s,value:s},s);})),
      React.createElement("select",{value:stat,onChange:function(e){setStat(e.target.value);},
        style:{padding:"7px 10px",background:T.inset,border:"1px solid "+T.border,color:T.text,fontSize:12,outline:"none",borderRadius:8}},
        React.createElement("option",{value:""},"All Statuses"),
        statuses.map(function(s){return React.createElement("option",{key:s,value:s},s);})),
      scanners.length>0&&React.createElement("select",{value:scanner,onChange:function(e){setScanner(e.target.value);},
        style:{padding:"7px 10px",background:T.inset,border:"1px solid "+T.border,color:T.text,fontSize:12,outline:"none",borderRadius:8}},
        React.createElement("option",{value:""},"All Scanners"),
        scanners.map(function(s){return React.createElement("option",{key:s,value:s},s);})),
      React.createElement("div",{style:{display:"flex",alignItems:"center",gap:12}},
        React.createElement("span",{style:{fontSize:12,color:T.text3,whiteSpace:"nowrap"}},sorted.length+" of "+myVulns.length),
        sorted.length>PAGE_SIZE&&React.createElement("div",{style:{display:"flex",gap:4}},
          React.createElement("button",{onClick:function(){setVPage(function(p){return Math.max(1,p-1);});},disabled:vPage<=1,
            style:{padding:"2px 8px",background:T.inset,border:"1px solid "+T.border,borderRadius:4,cursor:"pointer",fontSize:11,color:T.text2,opacity:vPage<=1?0.4:1}},"< Prev"),
          React.createElement("span",{style:{fontSize:11,color:T.text3}},vPage+"/"+Math.ceil(sorted.length/PAGE_SIZE)),
          React.createElement("button",{onClick:function(){setVPage(function(p){return Math.min(Math.ceil(sorted.length/PAGE_SIZE),p+1);});},disabled:vPage>=Math.ceil(sorted.length/PAGE_SIZE),
            style:{padding:"2px 8px",background:T.inset,border:"1px solid "+T.border,borderRadius:4,cursor:"pointer",fontSize:11,color:T.text2,opacity:vPage>=Math.ceil(sorted.length/PAGE_SIZE)?0.4:1}},"Next >")
        )
      )
    ),

    // Bulk actions
    selIds.length>0&&React.createElement("div",{style:{display:"flex",gap:8,alignItems:"center",background:T.accentBg,padding:"8px 12px",borderRadius:8,border:"1px solid "+PURPLE+"44"}},
      React.createElement("span",{style:{fontSize:12,color:PURPLE,fontWeight:600}},selIds.length+" selected"),
      React.createElement("select",{value:bulkStat,onChange:function(e){setBulkStat(e.target.value);},
        style:{padding:"5px 8px",background:T.inset,border:"1px solid "+T.border,color:T.text,fontSize:12,outline:"none",borderRadius:6}},
        React.createElement("option",{value:""},"Change status..."),
        statuses.map(function(s){return React.createElement("option",{key:s,value:s},s);})),
      React.createElement("button",{onClick:bulkUpdate,style:{background:PURPLE,color:"#fff",border:"none",padding:"5px 14px",cursor:"pointer",fontSize:12,fontWeight:600,borderRadius:6}},"Apply"),
      React.createElement("select",{
        onChange:async function(e){
          if(!e.target.value) return;
          var ownerId=e.target.value;
          await Promise.all(selIds.map(function(id){return api.patch("/vulns/"+id,{owner_id:ownerId}).catch(function(){});}));
          refreshVulns&&refreshVulns(); setSelIds([]); e.target.value="";
        },
        style:{padding:"4px 8px",background:T.inset,border:"1px solid "+PURPLE+"44",borderRadius:6,color:T.text,fontSize:12,cursor:"pointer"}
      },
        React.createElement("option",{value:""},"Assign owner..."),
        (users||[]).map(function(u){return React.createElement("option",{key:u.id,value:u.id},u.name+" ("+u.role+")");})
      ),
      React.createElement("button",{onClick:function(){setSelIds([]);},style:{background:"transparent",color:T.text3,border:"1px solid "+T.border,padding:"5px 10px",cursor:"pointer",fontSize:12,borderRadius:6}},"Clear")
    ),

    msg&&React.createElement("div",{style:{fontSize:12,color:msg.startsWith("Error")?"#e5534b":"#2ea043",padding:"6px 10px",background:T.inset,borderRadius:6}},msg),

    // Table
    React.createElement("div",{style:{background:T.card,borderRadius:12,overflow:"hidden",boxShadow:T.cardShadow}},
      React.createElement("table",{style:{width:"100%",borderCollapse:"collapse",tableLayout:"fixed"}},
        React.createElement("thead",null,
          React.createElement("tr",null,
            React.createElement("th",{style:Object.assign({},thS,{width:32})},
              React.createElement("input",{type:"checkbox",onChange:function(e){setSelIds(e.target.checked?sorted.map(function(v){return v.id;}):[]);},
                checked:selIds.length===sorted.length&&sorted.length>0})),
            [["id","ID",65],["scan_type","Type",55],["title","Title",260],["cve","CVE",135],["asset","Asset",115],
             ["severity","SEV",72],["status","Status",92],["owner_name","Owner",92],
             ["scanner_name","Scanner",82],["days_left","SLA",80]
            ].map(function(h){
              return React.createElement("th",{key:h[0],style:Object.assign({},thS,{width:h[2]}),
                onClick:function(){toggleSort(h[0]);}},
                h[1],sort.col===h[0]?React.createElement("span",{style:{marginLeft:3,color:PURPLE}},sort.dir==="asc"?" ↑":" ↓"):"");
            })
          )
        ),
        React.createElement("tbody",null,
          sorted.length===0
            ? React.createElement("tr",null,React.createElement("td",{colSpan:10,style:{padding:40,textAlign:"center",color:T.text3}},"No vulnerabilities found"))
            : sorted.slice((vPage-1)*PAGE_SIZE,vPage*PAGE_SIZE).map(function(v,i){
                var sc=SEV_C[v.severity]||T.text3;
                var stc=STAT_C[v.status]||T.text3;
                var overdue=v.days_left<0;
                var scanType=(v.scan_type||"manual").toUpperCase();
                return React.createElement("tr",{key:v.id,
                  style:{background:selIds.includes(v.id)?PURPLE+"12":i%2===0?T.card:T.inset,cursor:"pointer",transition:"background .1s"},
                  onClick:function(){setSelVuln(v);}},
                  React.createElement("td",{style:tdS,onClick:function(e){e.stopPropagation();toggleSel(v.id);}},
                    React.createElement("input",{type:"checkbox",checked:selIds.includes(v.id),readOnly:true})),
                  // ID + dup badge
                  React.createElement("td",{style:Object.assign({},tdS,{fontWeight:700,color:PURPLE,fontSize:11})},
                    React.createElement("div",null,v.id),
                    v.dup_of&&React.createElement("div",{title:"Duplicate of "+v.dup_of,
                      style:{fontSize:9,color:"#f59e0b",marginTop:1,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}},
                      "⧖ "+v.dup_of)
                  ),
                  // Scan type
                  React.createElement("td",{style:tdS},
                    React.createElement("span",{style:{background:PURPLE+"15",color:PURPLE,padding:"1px 5px",borderRadius:4,fontSize:10,fontWeight:700}},scanType)
                  ),

                  // Title
                  React.createElement("td",{style:Object.assign({},tdS,{fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",maxWidth:220})},v.title),
                  // CVE
                  React.createElement("td",{style:Object.assign({},tdS,{fontSize:11,color:T.text2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",fontFamily:"monospace"})},
                    (v.cve&&/^CVE-\d{4}-\d+$/i.test(v.cve))?v.cve.toUpperCase():"—"),
                  // Asset
                  React.createElement("td",{style:Object.assign({},tdS,{color:T.text2,fontSize:11,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"})},v.asset),
                  // Severity
                  React.createElement("td",{style:tdS},
                    React.createElement("span",{style:{background:sc+"20",color:sc,padding:"2px 8px",borderRadius:20,fontSize:11,fontWeight:700}},v.severity)
                  ),
                  // Status
                  React.createElement("td",{style:tdS},
                    React.createElement("span",{style:{background:stc+"20",color:stc,padding:"2px 8px",borderRadius:20,fontSize:11,fontWeight:600}},v.status)
                  ),
                  // Owner
                  React.createElement("td",{style:Object.assign({},tdS,{fontSize:11,color:T.text2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"})},v.owner_name||"—"),
                  // Scanner
                  React.createElement("td",{style:Object.assign({},tdS,{fontSize:11,color:T.text3,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"})},v.scanner_name||"—"),
                  // SLA
                  React.createElement("td",{style:Object.assign({},tdS,{fontWeight:600,color:overdue?"#e5534b":v.days_left<=3?"#d29922":"#2ea043",fontSize:11,whiteSpace:"nowrap"})},
                    overdue?Math.abs(v.days_left)+"d over":(v.days_left||0)+"d left")
                );
              })
        )
      )
    ),
    scanTab==="kev"&&!kevList.length&&!kevLoading&&(function(){
      setKevLoading(true);
      api.get("/integrations/kev-catalogue").then(function(d){setKevList(d||[]);setKevLoading(false);}).catch(function(){setKevLoading(false);});
      return null;
    })(),
    scanTab==="kev"&&React.createElement("div",{style:{marginTop:14,display:"flex",flexDirection:"column",gap:12}},
      // KEV summary KPIs
      (function(){
        var kevVulns=myVulns.filter(function(v){return v.kev&&v.status!=="Remediated"&&v.status!=="Exception";});
        var kevCves=new Set(kevVulns.map(function(v){return v.cve;}));
        var kevRemediated=myVulns.filter(function(v){return v.kev&&v.status==="Remediated";}).length;
        var kevOverdue=kevVulns.filter(function(v){return v.days_left<0;}).length;
        return React.createElement("div",{style:{display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(120px,1fr))",gap:10}},
          [{label:"KEV CVEs in your env",val:kevCves.size,c:"#ef4444",sub:"of "+kevList.length+" total KEV"},
           {label:"Open KEV vulns",val:kevVulns.length,c:"#f97316",sub:"need immediate action"},
           {label:"Overdue KEV",val:kevOverdue,c:"#dc2626",sub:"SLA breached"},
           {label:"KEV Remediated",val:kevRemediated,c:"#22c55e",sub:"cleared from env"},
          ].map(function(k){
            return React.createElement(Card,{key:k.label,style:{textAlign:"center",padding:"10px 8px"}},
              React.createElement("div",{style:{fontSize:22,fontWeight:700,color:k.c}},k.val),
              React.createElement("div",{style:{fontSize:11,color:T.text,marginTop:2,fontWeight:600}},k.label),
              React.createElement("div",{style:{fontSize:10,color:T.text3,marginTop:1}},k.sub)
            );
          })
        );
      })(),
      React.createElement("div",{style:{background:T.card,borderRadius:10,overflow:"hidden",border:"1px solid "+T.border}},
      React.createElement("div",{style:{padding:"12px 16px",borderBottom:"1px solid "+T.border,display:"flex",alignItems:"center",justifyContent:"space-between",gap:10,flexWrap:"wrap"}},
        React.createElement("div",null,
          React.createElement("div",{style:{fontSize:13,fontWeight:700,color:T.text}},"KEV CVEs found in your environment"),
          React.createElement("div",{style:{fontSize:11,color:T.text3,marginTop:2}},"Only showing CVEs from CISA KEV that match vulnerabilities in AVTA")
        ),
        React.createElement("div",{style:{display:"flex",gap:8,alignItems:"center"}},
          React.createElement("input",{placeholder:"Search CVE, vendor, product...",value:kevSearch,
            onChange:function(e){setKevSearch(e.target.value);},
            style:{padding:"6px 10px",background:T.inset,border:"1px solid "+T.border,
              borderRadius:6,color:T.text,fontSize:11,outline:"none",width:220}}),
          React.createElement("button",{onClick:function(){
            setKevLoading(true);
            api.get("/integrations/kev-catalogue").then(function(d){setKevList(d||[]);setKevLoading(false);}).catch(function(){setKevLoading(false);});
          },style:{padding:"5px 10px",background:T.inset,color:T.text2,border:"1px solid "+T.border,borderRadius:6,cursor:"pointer",fontSize:11}},
            kevLoading?"Loading...":React.createElement(Icon,{name:"RefreshCw",size:12}))
        )
      ),
      React.createElement("div",{style:{overflowX:"auto",maxHeight:"60vh",overflowY:"auto"}},
        React.createElement("table",{style:{width:"100%",borderCollapse:"collapse",fontSize:11}},
          React.createElement("thead",null,
            React.createElement("tr",null,
              ["CVE ID","Vendor","Product","Vulnerability","Due Date","In AVTA"].map(function(h){
                return React.createElement("th",{key:h,style:{padding:"8px 12px",textAlign:"left",
                  fontSize:9,fontWeight:700,color:T.text3,textTransform:"uppercase",
                  letterSpacing:.7,background:T.inset,borderBottom:"1px solid "+T.border,
                  whiteSpace:"nowrap",position:"sticky",top:0}},h);
              })
            )
          ),
          React.createElement("tbody",null,
            kevLoading
              ? React.createElement("tr",null,React.createElement("td",{colSpan:6,style:{padding:30,textAlign:"center",color:T.text3}},"Loading KEV catalogue..."))
              : (function(){
                  var kevCveMap={};
                  myVulns.filter(function(v){return v.kev&&v.cve;}).forEach(function(v){
                    if(!kevCveMap[v.cve])kevCveMap[v.cve]={vulns:[],maxSev:"Low",overdue:false};
                    kevCveMap[v.cve].vulns.push(v);
                    var sevRank={Critical:0,High:1,Medium:2,Low:3};
                    if((sevRank[v.severity]||3)<(sevRank[kevCveMap[v.cve].maxSev]||3))kevCveMap[v.cve].maxSev=v.severity;
                    if(v.days_left<0&&v.status!=="Remediated")kevCveMap[v.cve].overdue=true;
                  });
                  var rows=kevList.filter(function(k){
                    if(!kevCveMap[k.cveID]) return false;
                    if(!kevSearch) return true;
                    return (k.cveID+k.vendorProject+k.product+k.vulnerabilityName).toLowerCase().includes(kevSearch.toLowerCase());
                  }).slice(0,300);
                  if(!rows.length) return React.createElement("tr",null,
                    React.createElement("td",{colSpan:6,style:{padding:24,textAlign:"center",color:T.text3}},
                      kevList.length?("No KEV CVEs found in your environment — great news!"):"Load KEV catalogue first"));
                  return rows.map(function(k,i){
                    var found=kevCveMap[k.cveID];
                    var found=true;
                    return React.createElement("tr",{key:k.cveID,style:{background:found?"#DC262608":i%2===0?T.card:T.inset}},
                      React.createElement("td",{style:{padding:"7px 12px",fontWeight:700,color:found?"#DC2626":T.accent,borderBottom:"1px solid "+T.border,whiteSpace:"nowrap"}},
                        React.createElement("a",{href:"https://nvd.nist.gov/vuln/detail/"+k.cveID,target:"_blank",rel:"noopener noreferrer",style:{color:"inherit",textDecoration:"none"}},k.cveID)),
                      React.createElement("td",{style:{padding:"7px 12px",color:T.text2,borderBottom:"1px solid "+T.border}},k.vendorProject||"-"),
                      React.createElement("td",{style:{padding:"7px 12px",color:T.text2,borderBottom:"1px solid "+T.border}},k.product||"-"),
                      React.createElement("td",{style:{padding:"7px 12px",color:T.text,borderBottom:"1px solid "+T.border,maxWidth:200,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},k.vulnerabilityName||"-"),
                      React.createElement("td",{style:{padding:"7px 12px",color:T.text3,borderBottom:"1px solid "+T.border,whiteSpace:"nowrap"}},k.dueDate||"-"),
                      React.createElement("td",{style:{padding:"7px 12px",borderBottom:"1px solid "+T.border}},
                        React.createElement("div",{style:{display:"flex",gap:4,flexWrap:"wrap"}},
                          React.createElement("span",{style:{background:"#DC262618",color:"#DC2626",border:"1px solid #DC262633",padding:"2px 8px",borderRadius:4,fontSize:10,fontWeight:700}},
                            (kevCveMap[k.cveID]&&kevCveMap[k.cveID].vulns.length||0)+" vuln"+(kevCveMap[k.cveID]&&kevCveMap[k.cveID].vulns.length>1?"s":"")),
                          kevCveMap[k.cveID]&&kevCveMap[k.cveID].overdue&&React.createElement("span",{style:{background:"#ef444418",color:"#ef4444",border:"1px solid #ef444433",padding:"2px 6px",borderRadius:4,fontSize:10,fontWeight:700}},"OVERDUE")
                        )
                      )
                    );
                  });
                })()
          )
        )
      )
    )
  ));
}

